var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { create } from '../Style';

export default create({
	fixed: function fixed(style) {
		return _extends({
			position: 'absolute',
			top: 0,
			// width: 'inherit',
			left: 'inherit',
			right: 'inherit',
			paddingLeft: 'inherit',
			paddingRight: 'inherit',
			marginLeft: 'inherit',
			marginRight: 'inherit'
		}, style);
	},
	relative: function relative(style, topOrBottom) {
		return _extends(_defineProperty({
			position: 'absolute',
			zIndex: 1,
			left: 0,
			right: 0
		}, topOrBottom, 0), style);
	}
});